import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Batiment} from "../Models/Batiment";
import {AppComponent} from "../app.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
	EmailRegex,
	PhoneFrRegex,
	specialCompaniesButtonPartners,
	specialHideFormData
} from "../const/utils";
import {User} from "../Models/User";
import {Agency} from "../Models/Agency";
import {Adresse} from "../Models/Adresse";
import {ActivatedRoute} from '@angular/router';
import {AnalyticsService} from "../services/analytics.service";
import {ROUTES_PATHS} from "../const/routes";
import {UserTypes} from "../const/user-types";
import {UserType} from "../Models/UserType";
import {UserTypeEnum} from "../enums/user-type.enum";
import {UserTypeFormHelper} from "../helpers/user-type-form.helper";
import {SiteKeyEnum} from "../enums/site-key.enum";

@Component({
	selector: 'app-form-inscription',
	templateUrl: './form-inscription.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./form-inscription.component.less']
})
export class FormInscriptionComponent implements OnInit {
	textesForm: any = "";
	globalTxt: any = "";
	modalOpen: any = null;
	submitted = false;
	userForm!: FormGroup;
	refId: any = localStorage.getItem('refId');
	userId: any = localStorage.getItem('user_id');
	userRole: any = localStorage.getItem('user_role');
	form_created: boolean = false;
	showMessageIfEmailExist: boolean = false;
	isInscriptionPage: boolean = false;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	token = JSON.parse(localStorage.getItem("token")!);
	guid = JSON.parse(localStorage.getItem("guid")!);
	userTypes: UserType[] = UserTypes;

	constructor(
		public app: AppComponent,
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private userTypeFormHelper: UserTypeFormHelper,
		public analyticsService: AnalyticsService
	) {
	}

	get f() {
		return this.userForm.controls;
	}

	ngOnInit(): void {
		let nameJsonForm: string = "txtFormInscription";
		this.getInfosInit(nameJsonForm);

		// Determine if the current page is the inscription page
		this.route.url.subscribe(url => {
			this.isInscriptionPage = url.some(segment => segment.path === ROUTES_PATHS.INSCRIPTION);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			this.userTypes = this.userTypes.map(userType => {
				return {
					...userType,
					Label: this.globalTxt.formFields[userType.Label] || userType.Label
				}
			});

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textesForm = textes;

					this.doUserForm(null);
				});
		});
	}

	doUserForm(_user: any) {
		const controls: { [key: string]: any[] } = {
			USR_NOM: [_user ? _user?.USR_NOM : '', [Validators.required]],
			USR_PRENOM: [_user ? _user?.USR_PRENOM : '', [Validators.required]],
			USR_EMAIL: [_user ? _user?.USR_EMAIL : '', [Validators.required, Validators.pattern(EmailRegex)]],
			USR_TEL_MOBILE: [_user ? _user?.USR_TEL_MOBILE : '', [Validators.required, Validators.pattern(PhoneFrRegex)]],
			USR_ORG_LIBELLE: [_user ? _user?.USR_ORG_LIBELLE : ''],
			USR_ADR_CP: [_user ? _user?.USR_ADR_CP : ''],
			USR_REFERER: [_user ? _user?.USR_REFERER : ''],
			cguOk: [false, [Validators.requiredTrue]]
		};

		if (specialHideFormData.includes(this.app.sharedToolsService.returnObjectSwitchRefId())) {
			delete controls.USR_ORG_LIBELLE;
			delete controls.USR_REFERER;
		}

		// Dynamic addition of fields with showOnlyInInsPage: true only on the registration page.
		if (this.textesForm?.formFields) {
			this.textesForm.formFields.forEach((item: any) => {
				if (item.param === 'USR_TYPE' && this.isInscriptionPage) {
					controls[item.param] = [null, [Validators.required]];
					item.options = this.userTypes;
				}
			});
		}

		this.userForm = this.formBuilder.group(controls);
		console.log("this.userForm ==> ", this.userForm);

		// Set the form created to true
		this.form_created = true;


		this.userForm.get('USR_TYPE')?.valueChanges.subscribe(value => {
			console.log("value ==> ", value);
			this.userTypeFormHelper.onTypeIdChange(value, 'USR_TYPE_REFERER', this.textesForm.formFields, this.userForm, false, this.app.sharedToolsService);
		});
	}

	onSubmit(acteId: number) {
		//acteId = (this.token?.refId != 14) ? acteId : 3; //KtvFree

		// Force acteId to 3 if "Referential" is KtvFree
		if (this.app.sharedToolsService.returnObjectSwitchRefId() == SiteKeyEnum.KOUTRAVOFREE) acteId = 3;

		// Force acteId to 99 if "Referential" is Arthurimmo || WeInvestClient
		if (this.app.sharedToolsService.returnObjectSwitchRefId() == SiteKeyEnum.ARTHURIMMO || this.app.sharedToolsService.returnObjectSwitchRefId() == SiteKeyEnum.WEINVESTCLIENT) acteId = 99;

		console.log("this.userForm ==> ", this.userForm);
		console.log("this.userForm.value ==> ", this.userForm.value);
		console.log("acteId ==> ", acteId);
		//console.log("guid:", this.guid);

		this.showMessageIfEmailExist = false;
		this.submitted = true;

		if (this.userForm.invalid) {
			// ==> Show errorMessage
			console.log("Erreur dans le formulaire userForm");
			return;
		} else {
			console.log("Formulaire userForm valide");

			/* Validate the partner code if exists in the form */
			if (this.userForm.value.USR_REFERER && this.userForm.value.USR_REFERER !== '') {
				this.app.apiToolsService.validateCodeReferer(this.userForm.value.USR_REFERER).subscribe(
					(res: any) => {
						console.log("res validateCodeReferer ==> ", res);
						let isValid: boolean = res;
						if (!isValid) {
							this.userForm.value.USR_REFERER = '';
							this.app.confirmDialogService.confirmThis(
								'',
								this.textesForm.texteMsgCodePartenaireKo,
								"alert",
								"",
								() => { console.log("Code partenaire erroné !"); },
								() => {}
							);
							// ❌ Ici on retourne, et le reste ne s’exécute pas
							return;
						}

						// ✅ Tout le reste doit être ici
						this.submitUser(acteId);
					},
					(error: any) => {
						console.error(error.error);
						this.app.confirmDialogService.confirmThis(
							'',
							this.globalTxt.modalErrorApi,
							"alert",
							"",
							() => {},
							() => {}
						);
						return;
					}
				);
			} else {
				// Si pas de code partenaire, on continue
				this.submitUser(acteId);
			}
		}
	}

	private submitUser(acteId: number) {
		const user = new User();
		user.USR_ORG = new Agency();
		user.USR_ADR = new Adresse();
		user.USR_NOM = this.userForm.value.USR_NOM;
		user.USR_PRENOM = this.userForm.value.USR_PRENOM;
		user.USR_EMAIL = this.userForm.value.USR_EMAIL;
		user.USR_TEL_MOBILE = this.userForm.value.USR_TEL_MOBILE;
		user.USR_ORG.ORG_LIBELLE = this.userForm.value.USR_ORG_LIBELLE ?? '';
		user.USR_ADR.ADR_CP = this.userForm.value.USR_ADR_CP;
		user.USR_TYPE = this.userForm.value.USR_TYPE ?? UserTypeEnum.PARTICULIER;
		user.USR_TYPE_REFERER = this.userForm.value.USR_TYPE_REFERER ?? '';
		if (this.refId) user.REF_ID = this.refId;
		if (this.batiment?.simulationId && acteId != 0) user.SIN_ID = parseInt(this.batiment?.simulationId);
		user.ACTE_ID = acteId;
		user.USR_REFERER = this.userForm.value.USR_REFERER ?? '';
		user.USR_NUMERO_EXTERNE = this.token?.guid ?? this.guid ?? '';

		// Tracking
		let eventAction: string = (acteId == 1) ? 'click_estimation_payante' : (acteId == 2) ? 'click_mise_en_relation' : (acteId == 3 || acteId == 99) ? 'click_estimation_gratuite' : 'click_inscription';
		let eventLabel: string = (acteId == 1) ? 'value : Téléchargement estimation payante' : (acteId == 2) ? 'value : Mise en relation entreprises' : (acteId == 3 || acteId == 99) ? 'value : Téléchargement estimation gratuite' : 'value : Inscription';
		this.analyticsService.trackEvent('user_interaction', eventAction, eventLabel);

		this.inscription(user, acteId);
	}

	inscription(userDto: User, acteId: number) {
		this.app.apiToolsService.inscription(userDto).subscribe(
			(res: any) => {
				console.log("res inscription ==> ", res);

				// Replace localstorga var token with the new token if click on button téléchargement (acte_id 1)
				if (acteId == 1 || acteId == 3 || acteId == 99) localStorage.setItem("token", JSON.stringify(res));

				let aditional_text: string = (acteId == 1)
					? this.textesForm.texteMsgActeId1 : (acteId == 2)
						? this.textesForm.texteMsgActeId2 : (acteId == 3 || acteId == 99)
							? this.textesForm.texteMsgActeId3 : this.textesForm.texteMsgActeId0;

				this.app.confirmDialogService.confirmThis('', this.textesForm.texteInsOk + '<br/>' + aditional_text, "alert", "",
					() => {
						localStorage.removeItem("modalOpen");
						if (acteId == 1) {
							// ==> Call new api to get procudtId and priceId seloger -pass refID
							this.app.apiToolsService.getProductByRefId(this.token?.refId).subscribe(
								(res: any) => {
									console.log("res getProductByRefId ==> ", res);

									// ==> Call goToStripe(productId, priceId) to redirect to the payment page
									this.app.sharedToolsService.goToStripe(res.ProductId, res.PriceId);
								},
								(error: any) => {
									console.error(error.error);
								});
						} else if (acteId == 2) {
							// Remove the modalOpen from localStorage to avoid problems
							localStorage.removeItem("modalOpen");
							// Redirect to partner page
							this.app.router.navigate(['/' + ROUTES_PATHS.PARTENAIRES]);
						} else if (acteId == 3 || acteId == 99) {
							// Remove the modalOpen from localStorage to avoid problems
							localStorage.removeItem("modalOpen");

							// ==> Generation Chiffrage et Mobilier
							this.app.apiToolsService.generationSurfaceEtMobilierSimulation(parseInt(this.batiment.simulationId!)).subscribe(
								resp => {
									console.log("res generationSurfaceEtMobilierSimulation", resp);

									// Redirect to result page
									this.app.router.navigate(['/' + ROUTES_PATHS.ESTIMATION_RAPIDE]);
								},
								error => {
									if (error.error === "OUT_OF_SIMU") {
										this.getModalOutOfSimuAndRedirectToLogin();
									} else {
										console.error(error);
									}
								}
							);
						} else {
							// ==> Redirect to the home page if this is the inscription page or acteId is 0
							this.app.router.navigate(['/']);
						}
					},
					() => {
					});
			},
			(error: any) => {
				console.error(error.error);
				if (error.error === "OUT_OF_SIMU") {
					this.getModalOutOfSimuAndRedirectToLogin();
					return;
				}

				if (error.status === 409) {
					this.showMessageIfEmailExist = true;
					return;
				}
			});
	}

	// Return true if the return of this.app.sharedToolsService.returnObjectSwitchRefId() is in array specialCompaniesButtonPartners
	showButtonPartner(): boolean {
		return specialCompaniesButtonPartners.includes(this.app.sharedToolsService.returnObjectSwitchRefId());
	}

	getModalOutOfSimuAndRedirectToLogin() {
		this.app.confirmDialogService.confirmThis(
			'',
			this.textesForm.texteMsgOutOfSimu,
			"alert",
			"",
			() => {
				localStorage.clear();
				this.app.router.navigate(['/' + ROUTES_PATHS.LOGIN]);
			},
			() => {
			}
		);
	}

	public readonly SiteKeyEnum = SiteKeyEnum;
}
